"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CartClient = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _index = require("../utils/client.utils/index.js");
var _index2 = require("../constants/index.js");
var _excluded = ["cartId"],
  _excluded2 = ["cartId"],
  _excluded3 = ["cartId"];
var CartClient = exports.CartClient = {
  getCart: function getCart(_ref) {
    var productType = _ref.productType,
      cartId = _ref.cartId;
    var requestId = "GET_" + productType + "_CART";
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.GET_CART, {
      cartId: cartId
    });
    return _http.$http.get(requestId, endPoint).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  checkout: function checkout(_ref3) {
    var productType = _ref3.productType,
      payload = _ref3.payload;
    var requestId = "CHECKOUT_" + productType + "_CART";
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.CHECKOUT, {
      cartId: payload.cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  refreshCart: function refreshCart(_ref5) {
    var payload = _ref5.payload;
    var requestId = 'REFRESH_CART';
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.REFRESH_CART, {
      cartId: payload.cartId
    });
    return _http.$http.patch(requestId, endPoint, {
      data: payload
    }).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  },
  paylaterCheckout: function paylaterCheckout(payload) {
    var requestId = 'PAYLATER_CHECKOUT_HOTEL_CART';
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.PAYLATER_CHECKOUT, {
      orderNumber: payload.orderNumber
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref7) {
      var data = _ref7.data;
      return data;
    });
  },
  initRedeem: function initRedeem(payload) {
    // clean up
    var requestId = 'QITAF_INIT_REDEEM';
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.INIT_REDEEM, {
      cartId: payload.cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref8) {
      var data = _ref8.data;
      return data;
    });
  },
  redeemQitaf: function redeemQitaf(_ref9) {
    var cartId = _ref9.cartId,
      payload = (0, _objectWithoutPropertiesLoose2["default"])(_ref9, _excluded);
    var requestId = "QITAF_REDEEM_CART";
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.LOYALTY_REDEEM, {
      cartId: cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref10) {
      var data = _ref10.data;
      return data;
    });
  },
  redeemMokafaa: function redeemMokafaa(_ref11) {
    var cartId = _ref11.cartId,
      payload = (0, _objectWithoutPropertiesLoose2["default"])(_ref11, _excluded2);
    var requestId = "MOKAFAA_REDEEM_CART";
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.LOYALTY_REDEEM, {
      cartId: cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref12) {
      var data = _ref12.data;
      return data;
    });
  },
  redeemWallet: function redeemWallet(_ref13) {
    var cartId = _ref13.cartId,
      payload = (0, _objectWithoutPropertiesLoose2["default"])(_ref13, _excluded3);
    var requestId = "WALLET_REDEEM_CART";
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.LOYALTY_REDEEM, {
      cartId: cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref14) {
      var data = _ref14.data;
      return data;
    });
  },
  applyCoupon: function applyCoupon(payload) {
    var requestId = "APPLY_COUPON_" + payload.productType;
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.APPLY_COUPON, {
      cartId: payload.cartId,
      couponCode: payload.couponCode
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(function (_ref15) {
      var data = _ref15.data;
      return data;
    });
  },
  removeCoupon: function removeCoupon(payload) {
    var requestId = "REMOVE_COUPON_" + payload.productType;
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.REMOVE_COUPON, {
      cartId: payload.cartId
    });
    return _http.$http["delete"](requestId, endPoint, {
      data: payload
    }).then(function (_ref16) {
      var data = _ref16.data;
      return data;
    });
  },
  getOrder: function getOrder(_ref17) {
    var orderId = _ref17.orderId,
      orderNumber = _ref17.orderNumber;
    var requestId = 'RETRIEVE_ORDER';
    var endPoint = (0, _index.replaceParams)(_index2.ENDPOINTS.CHECKOUT.GET_ORDER, {
      orderId: orderId,
      orderNumber: orderNumber
    });
    return _http.$http.get(requestId, endPoint, {
      params: {
        orderId: orderId
      }
    }).then(function (_ref18) {
      var data = _ref18.data;
      return data;
    });
  }
};